var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-link",class:{'active': _vm.$route.path.startsWith(_vm.link.to)},attrs:{"to":_vm.link.to}},[(_vm.link.icon)?_c('fai',{attrs:{"icon":_vm.link.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.link.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }